module.exports = __webpack_public_path__ + "img/shortcut-booking-client.a180f7f7.svg";